import { useMutation } from '@tanstack/react-query';
import { updateUserLanguage } from 'config/requests';

export function useUpdateUserLanguage() {
  return useMutation({
    mutationFn: (language: 'ru' | 'en') => updateUserLanguage(language),
  });
}
